<template>
    <div class="filters__select-option">
        <div class="text--caption">{{ label }}</div>
        <div class="select__wrapper">
          <select class="form__input--select" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
            <option value="" selected>{{ defaultValue }}</option>
            <template v-if="Array.isArray(options)">
                <option v-for="(option) in options" :value="option.id">
                    {{ option.title }}
                </option>   
            </template>
            <template v-else>
                <option v-for="(option) in options" :value="option">
                    {{ option }}
                </option>
            </template>
          </select>
          <svg-vue class="icon" icon="down-icon"></svg-vue>
        </div>
      </div>
</template>

<script>

export default {
  name: 'SelectOption',
  props: ['modelValue', 'options', 'label', 'defaultValue'],
  emits: ['update:modelValue']
}
</script>